import { Table } from "semantic-ui-react";
import { clearDivWrapper, DisplayFromFHIRXhtml } from "../datatypeComponents/NarrativeEntry";
import { DisplayFromFHIRReference } from "../datatypeComponents/ReferenceEntry";
import getIdFromReference from "../functions/getIdFromReference";

const generatedNarrativeFromEvidenceTable = (resultsSections) => {
    let innerDiv = "";
    try {
        let screenedEvidenceFound;
        let enrolledEvidenceFound;
        let analyzedEvidenceFound;
        let interventionEvidenceFound;
        let comparatorEvidenceFound;
        let comparativeEvidenceFound;
        let populationGroupFound;
        let interventionGroupFound;
        let comparatorGroupFound;
        for (const section of resultsSections) {
            if (section?.section?.length) {
                for (const subsection of section.section) {
                    let sectionCode = subsection?.code?.coding?.[0]?.code;
                    if (subsection?.focus) {
                        switch (sectionCode) {
                            case 'evidence-for-screened-group':
                                screenedEvidenceFound = subsection.focus?.display || true;
                                break;
                            case 'evidence-for-enrolled-group':
                                enrolledEvidenceFound = subsection.focus?.display || true;
                                break;
                            case 'evidence-for-analyzed-group':
                                analyzedEvidenceFound = subsection.focus?.display || true;
                                break;
                            case 'evidence-with-intervention-alone':
                                interventionEvidenceFound = subsection.focus?.display || true;
                                break;
                            case 'evidence-with-comparator-alone':
                                comparatorEvidenceFound = subsection.focus?.display || true;
                                break;
                            case 'comparative-results':
                                comparativeEvidenceFound = subsection.focus?.display || true;
                                break;
                            case 'population':
                                populationGroupFound = subsection.focus?.display || true;
                                break;
                            case 'intervention-group':
                                interventionGroupFound = subsection.focus?.display || true;
                                break;
                            case 'comparator-group':
                                comparatorGroupFound = subsection.focus?.display || true;
                                break;
                            default:
                            //
                        }
                    }
                }
            }
        }
        innerDiv = "<table><tr><th>Variable Name</th>";
        if (populationGroupFound) {
            innerDiv += "<th>Population</th>";
        }
        if (interventionGroupFound) {
            innerDiv += "<th>Intervention Group</th>";
        }
        if (comparatorGroupFound) {
            innerDiv += "<th>Comparator Group</th>";
        }
        if (screenedEvidenceFound) {
            innerDiv += "<th>Screened Group</th>";
        }
        if (enrolledEvidenceFound) {
            innerDiv += "<th>Enrolled Group</th>";
        }
        if (analyzedEvidenceFound) {
            innerDiv += "<th>Analyzed Group</th>";
        }
        if (interventionEvidenceFound) {
            innerDiv += "<th>With Intervention</th>";
        }
        if (comparatorEvidenceFound) {
            innerDiv += "<th>With Comparator</th>";
        }
        if (comparativeEvidenceFound) {
            innerDiv += "<th>Comparative Evidence</th>";
        }
        innerDiv += "</tr>";
        innerDiv += "<tr>";
        if (populationGroupFound && typeof populationGroupFound === "string") {
            innerDiv += "<td>" + populationGroupFound + "</td>";
        }
        if (interventionGroupFound && typeof interventionGroupFound === "string") {
            innerDiv += "<td>" + interventionGroupFound + "</td>";
        }
        if (comparatorGroupFound && typeof comparatorGroupFound === "string") {
            innerDiv += "<td>" + comparatorGroupFound + "</td>";
        }
        if (screenedEvidenceFound && typeof screenedEvidenceFound === "string") {
            innerDiv += "<td>" + screenedEvidenceFound + "</td>";
        }
        if (enrolledEvidenceFound && typeof enrolledEvidenceFound === "string") {
            innerDiv += "<td>" + enrolledEvidenceFound + "</td>";
        }
        if (analyzedEvidenceFound && typeof analyzedEvidenceFound === "string") {
            innerDiv += "<td>" + analyzedEvidenceFound + "</td>";
        }
        if (interventionEvidenceFound && typeof interventionEvidenceFound === "string") {
            innerDiv += "<td>" + interventionEvidenceFound + "</td>";
        }
        if (comparatorEvidenceFound && typeof comparatorEvidenceFound === "string") {
            innerDiv += "<td>" + comparatorEvidenceFound + "</td>";
        }
        if (comparativeEvidenceFound && typeof comparativeEvidenceFound === "string") {
            innerDiv += "<td>" + comparativeEvidenceFound + "</td>";
        }
        innerDiv += "</tr>";
        resultsSections.map((itemSection) => {
            let populationSection = null;
            let interventionGroupSection = null;
            let comparatorGroupSection = null;
            let screenedEvidenceSection = null;
            let enrolledEvidenceSection = null;
            let analyzedEvidenceSection = null;
            let interventionEvidenceSection = null;
            let comparatorEvidenceSection = null;
            let comparativeEvidenceSection = null;
            if (Array.isArray(itemSection.section)) {
                for (let subsection of itemSection.section) {
                    let subsectionCode = subsection.code?.coding?.[0]?.code;
                    if (subsectionCode === "evidence-with-comparator-alone") {
                        comparatorEvidenceSection = subsection;
                    } else if (subsectionCode === "evidence-with-intervention-alone") {
                        interventionEvidenceSection = subsection;
                    } else if (subsectionCode === "evidence-for-analyzed-group") {
                        analyzedEvidenceSection = subsection;
                    } else if (subsectionCode === "comparative-results" || subsectionCode === "evidence-with-intervention-vs-comparator") {
                        comparativeEvidenceSection = subsection;
                    } else if (subsectionCode === "population") {
                        populationSection = subsection;
                    } else if (subsectionCode === "evidence-for-enrolled-group") {
                        enrolledEvidenceSection = subsection;
                    } else if (subsectionCode === "evidence-for-screened-group") {
                        screenedEvidenceSection = subsection;
                    } else if (subsectionCode === "intervention-group") {
                        interventionGroupSection = subsection;
                    } else if (subsectionCode === "comparator-group") {
                        comparatorGroupSection = subsection;
                    }
                }
                innerDiv += "<tr>";
                innerDiv += "<td>" + (itemSection.title || itemSection.focus?.display) + "</td>";
                if (populationGroupFound) {
                    innerDiv += "<td>";
                    if (populationSection) {
                        innerDiv += clearDivWrapper(populationSection.text?.div);
                    }
                    innerDiv += "</td>";
                }
                if (interventionGroupFound) {
                    innerDiv += "<td>";
                    if (interventionGroupSection) {
                        innerDiv += clearDivWrapper(interventionGroupSection.text?.div);
                    }
                    innerDiv += "</td>";
                }
                if (comparatorGroupFound) {
                    innerDiv += "<td>";
                    if (comparatorGroupSection) {
                        innerDiv += clearDivWrapper(comparatorGroupSection.text?.div);
                    }
                    innerDiv += "</td>";
                }
                if (screenedEvidenceFound) {
                    innerDiv += "<td>";
                    if (screenedEvidenceSection) {
                        innerDiv += clearDivWrapper(screenedEvidenceSection.text?.div);
                    }
                    innerDiv += "</td>";
                }
                if (enrolledEvidenceFound) {
                    innerDiv += "<td>";
                    if (enrolledEvidenceSection) {
                        innerDiv += clearDivWrapper(enrolledEvidenceSection.text?.div);
                    }
                    innerDiv += "</td>";
                }
                if (analyzedEvidenceFound) {
                    innerDiv += "<td>";
                    if (analyzedEvidenceSection) {
                        innerDiv += clearDivWrapper(analyzedEvidenceSection.text?.div);
                    }
                    innerDiv += "</td>";
                }
                if (interventionEvidenceFound) {
                    innerDiv += "<td>";
                    if (interventionEvidenceSection) {
                        innerDiv += clearDivWrapper(interventionEvidenceSection.text?.div);
                    }
                    innerDiv += "</td>";
                }
                if (comparatorEvidenceFound) {
                    innerDiv += "<td>";
                    if (comparatorEvidenceSection) {
                        innerDiv += clearDivWrapper(comparatorEvidenceSection.text?.div);
                    }
                    innerDiv += "</td>";
                }
                if (comparativeEvidenceFound) {
                    innerDiv += "<td>";
                    if (comparativeEvidenceSection) {
                        innerDiv += clearDivWrapper(comparativeEvidenceSection.text?.div);
                    }
                    innerDiv += "</td>";
                }
                innerDiv += "</tr>";
            }
            return null;
        })
        innerDiv += "</table>";
    } catch {
        innerDiv = "[Unable to generate Narrative Summary.]"
    }
    return {
        "status": "generated",
        "div": '<div xmlns="http://www.w3.org/1999/xhtml">' + innerDiv + "</div>"
    };
}
/*
            resourceLoaded is a state with shape of ({
                "title": fhirJson.title,
                "sections": fhirJson.section,
                "json": fhirJson,
                "generatedNarrative": generatedNarrative,
                "resourceDictionary": resourceDictionary,
                "resultsSectionsKeys": resultsSectionsKeys,
                "resultsSectionsDictionary": resultsSectionsDictionary,
                "containedDictionary": containedDictionary,
                "combinedDictionary": combinedDictionary,
                "groupReferencesDictionary": groupReferencesDictionary,
                "evidenceDisplayDictionary": evidenceDisplayDictionary,
                "hasResourceCollection": Object.keys(resourceDictionary).length > 0
            });
*/

const EvidenceTableDisplay = ({ resourceLoaded }) => {

    const resultsSectionsDictionary = resourceLoaded.resultsSectionsDictionary;
    const resultsSectionsKeys = resourceLoaded.resultsSectionsKeys;
    const groupReferencesDictionary = resourceLoaded.groupReferencesDictionary;
    const groupKeys = Object.keys(groupReferencesDictionary);
    const combinedDictionary = resourceLoaded.combinedDictionary;
    const evidenceDisplayDictionary = resourceLoaded.evidenceDisplayDictionary;

    return <>
        {groupKeys.length ?
            <Table>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Variable Name</Table.HeaderCell>
                        {groupKeys.map((groupKey) => {
                            return <Table.HeaderCell key={groupKey}>{groupReferencesDictionary[groupKey].display}</Table.HeaderCell>
                        })}
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {resultsSectionsKeys?.length && resultsSectionsKeys.map((sectionKey, index) => {
                        let section = resultsSectionsDictionary[sectionKey];
                        let evidenceForGroupDictionary = {};
                        if (!section.entry || section.entry.length === 0) {
                            return <Table.Row key={index}>
                                <Table.Cell style={{ verticalAlign: "top" }}>
                                    {section.focus?.display || section.title}
                                </Table.Cell>
                                {groupKeys.map((groupKey) => {
                                    return <Table.Cell key={groupKey} style={{ verticalAlign: "top" }}>
                                        <p>[No data.]</p>
                                    </Table.Cell>
                                })}
                            </Table.Row>
                        }
                        for (let entry of section.entry) {
                            let evidenceId = getIdFromReference(entry);
                            const Evidence = combinedDictionary[evidenceId]; //Evidence Resource JSON
                            if (Evidence) {
                                let groupReference = Evidence.variableDefinition[0].observed || Evidence.variableDefinition[0].intended;
                                if (Evidence.meta?.profile?.[0] === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence" ||
                                    Evidence.variableDefinition[1].variableRole === "exposure"
                                ) {
                                    groupReference = Evidence.variableDefinition[1].observed || Evidence.variableDefinition[1].intended;
                                }
                                let groupReferenceId = getIdFromReference(groupReference);
                                evidenceForGroupDictionary[groupReferenceId] = evidenceId;
                            }
                        }

                        return <Table.Row key={index}>
                            <Table.Cell style={{ verticalAlign: "top" }}>
                                {section.focus?.display || section.title}
                            </Table.Cell>
                            {groupKeys.map((groupKey) => {
                                const evidenceId = evidenceForGroupDictionary[groupKey];
                                return <Table.Cell key={groupKey} style={{ verticalAlign: "top" }}>
                                    {(evidenceId && evidenceDisplayDictionary[evidenceId]) && <span>
                                        {evidenceDisplayDictionary[evidenceId]}
                                    </span>}
                                </Table.Cell>
                            })}
                        </Table.Row>
                    })}
                </Table.Body>
            </Table>
            :
            <><p>There are no results sections to produce an evidence table.</p></>
        }
    </>
}

export default EvidenceTableDisplay;
export { generatedNarrativeFromEvidenceTable };